/* __next_internal_client_entry_do_not_use__ VideoSeekbarProgressChapters auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const VideoSeekbarProgressChapters = /*#__PURE__*/ memo((param)=>{
    let { chapters, duration } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none absolute inset-0 flex items-center",
        children: chapters.map((chapter, index)=>{
            if (index === 0) return null;
            const position = chapter.startTime / duration * 100;
            return /*#__PURE__*/ _jsx("div", {
                className: "absolute z-10 h-1.5 w-1 -translate-x-1/2 bg-grey-2",
                style: {
                    left: "".concat(position, "%")
                }
            }, chapter.startTime);
        })
    });
});
VideoSeekbarProgressChapters.displayName = "VideoSeekbarProgressChapters";
